export default function CsharpDowhile() {
  return (
    <h2>Csharp DoWhile</h2>
  );
}
